import moment from 'moment';

export const toDefaultDateFormatOrNotAvailable = (
	input: Date | string | undefined,
	textIfNotAvailable = 'N/A',
	format = 'DD MMM YYYY HH:mm',
): string => {
	if (!input) {
		return textIfNotAvailable;
	}

	const defaultDateTime = moment.utc('0001-01-01');
	const date = moment.utc(input);

	if (date.unix() === 0) {
		return textIfNotAvailable;
	}

	if (date.isAfter(defaultDateTime)) return toDefaultDateFormat(date, format);

	return textIfNotAvailable;
};

export const toDefaultDateFormat = (
	input: Date | moment.Moment | string,
	format = 'DD MMM YYYY HH:mm',
): string => moment(input).utc().format(format);

export const convertDeliveryDateToDateFormat = (
	datetime: string | null,
): string => {
	if (datetime !== null) {
		return toDefaultDateFormat(datetime);
	} else {
		return 'Spot';
	}
};

export const getTimeRemainingInMinutes = (date: Date) =>
	(date.getTime() - Date.now()) / 1000 / 60;

export function getRemainingTime(endMs: number): number {
	// We compare with UTC timestamp.
	const timeNow = Date.now();
	const delta = endMs - timeNow;
	return delta > 0 ? delta : 0;
}

export function getMsAsDays(ms: number): number {
	return Math.floor(ms / 1000 / 60 / 60 / 24);
}
export function getMsAsMinutes(ms: number) {
	return Math.floor(ms / 1000 / 60);
}
